<template>
  <card-component title="Productos" icon="archive" class="column">
    <product-skeleton v-if="isLoading" />
    <card-component
      v-else
      v-for="product in products"
      :key="product.id"
      class="m-3"
    >
      <div class="is-flex-tablet is-align-items-center" style="gap: 2rem">
        <div>
          <div style="width: 190px">
            <img
              :src="product.image_crop"
              :alt="product.id"
              class="card"
              width="190px"
            />
          </div>
        </div>
        <div class="is-full">
          <h3 class="has-text-weight-medium is-size-4 mb-3">
            {{ product.name }}
          </h3>
          <div v-html="product.description"></div>
          <div
            class="mt-3 is-flex is-justify-content-space-between is-align-items-center"
          >
            <div class="">
              <p
                v-if="
                  hasValidate(
                    product.stock_client,
                    product.has_stock,
                    product.is_available
                  )
                "
              >
                Disponible:
                {{ getStock(product.stock_client, product.has_stock) }}
              </p>
              <p v-else class="has-text-weight-bold">No disponible</p>
            </div>
            <div
              class="is-flex flex-column is-align-items-center is-justify-content-space-between"
            >
              <b-button
                type="is-primary"
                :disabled="!product.is_available"
                @click.native="goValidate(product.id)"
              >
                Validar
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </card-component>
    <card-component v-if="locals.length > 0">
      <h5>Este local no cuenta con Descuentos.</h5>
      <h5>Locales con descuento:</h5>
      <ul>
        <li v-for="(local, index) in locals" :key="index">
          {{ local.name }}
        </li>
      </ul>
    </card-component>
    <hr />
    <b-button class="is-dark ml-2" @click.native="goBack"> Regresar </b-button>
  </card-component>
</template>

<script>
import CardComponent from "@/components/CardComponent";
import ProductSkeleton from "@/components/Validate/Skeleton/ProductSkeleton";
import ValidateService from "@/services/ValidateService";
export default {
  components: {
    CardComponent,
    ProductSkeleton,
  },
  props: {
    document: String,
    option: Number,
  },
  data() {
    return {
      products: [],
      locals: [],
      isLoading: false,
      stock: "",
    };
  },
  created() {
    this.getProductList();
  },
  methods: {
    goBack() {
      this.$emit("goBack", 0);
    },
    async getProductList() {
      this.isLoading = true;
      try {
        const response = await ValidateService.getProductList({
          num_document: this.document,
          company_provider_id: this.option,
          local_id: this.$localStorage.get("local"),
        });
        if (response.data.has_register_segment) {
          this.$emit("goBack", 7);
          return;
        }
        if (!response.data.products.length) {
          this.$emit("goBack", 2);
          return;
        }
        this.products = this.filterProducts(response.data.products);
        this.locals = response.data.locals;
      } catch (error) {
        this.$buefy.toast.open({
          message: "Ocurrió un error.",
          type: "is-danger",
        });
        this.$emit("goBack", 0);
      }
      this.isLoading = false;
    },
    getStock(stockClient, hasStock) {
      return `${stockClient - hasStock} de ${stockClient}`;
    },
    goValidate(id) {
      this.$emit("validateProduct", {
        step: 5,
        idProduct: id,
      });
    },
    hasValidate(stockClient, hasStock, isAvailable) {
      return stockClient > hasStock;
    },
    filterProducts(products) {
      console.log("[filterProducts] productos recibidos:", products);

      const groups = {};
      for (const product of products) {
        const key = product.type_discount;
        if (!groups[key]) groups[key] = [];
        groups[key].push(product);
      }
      console.log("[filterProducts] grupos por type_discount:", groups);

      const result = [];
      for (const key of Object.keys(groups)) {
        const group = groups[key];
        console.log(`[filterProducts] procesando grupo "${key}":`, group);

        if (group.length <= 1) {
          console.log(
            `[filterProducts] "${key}": sin duplicados, se agrega tal cual`
          );
          result.push(...group);
          continue;
        }

        const validated = group.filter((p) =>
          this.hasValidate(p.stock_client, p.has_stock, p.is_available)
        );
        console.log(
          `[filterProducts] "${key}": validados (hasValidate):`,
          validated
        );

        if (validated.length <= 1) {
          console.log(
            `[filterProducts] "${key}": menos de 2 validados, se agrega el grupo completo`
          );
          result.push(...group);
          continue;
        }

        const pricePctValue = (p) => {
          const val = parseFloat(p.price_percentage);
          return val === 0 ? Infinity : val;
        };

        const maxDiscount = Math.max(
          ...validated.map((p) => parseFloat(p.discount))
        );
        console.log(`[filterProducts] "${key}": mayor discount:`, maxDiscount);

        const byDiscount = validated.filter(
          (p) => parseFloat(p.discount) === maxDiscount
        );
        console.log(
          `[filterProducts] "${key}": filtrados por mayor discount:`,
          byDiscount
        );

        if (byDiscount.length === 1) {
          console.log(
            `[filterProducts] "${key}": ganador por discount:`,
            byDiscount[0]
          );
          result.push(byDiscount[0]);
          continue;
        }

        const maxPricePct = Math.max(...byDiscount.map(pricePctValue));
        console.log(
          `[filterProducts] "${key}": mayor price_percentage (0=Infinity):`,
          maxPricePct
        );

        const byPricePct = byDiscount.filter(
          (p) => pricePctValue(p) === maxPricePct
        );
        console.log(
          `[filterProducts] "${key}": filtrados por mayor price_percentage:`,
          byPricePct
        );

        result.push(...byPricePct);
      }

      console.log("[filterProducts] resultado final:", result);
      return result;
    },
  },
};
</script>
